(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/services/account.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/services/account.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  createQueryString,
  setURLParams
} = svs.tur.payment.utils.misc;
class Account {
  constructor() {
    let {
      returnParams,
      onCancel,
      isAutoPayAfterDeposit
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.returnParams = returnParams;
    this.onCancel = onCancel;
    this.isAutoPayAfterDeposit = isAutoPayAfterDeposit;
  }
  checkStatus(_ref) {
    let {
      price,
      productName
    } = _ref;
    const deferred = $.Deferred();
    const extraParams = _objectSpread({
      amount: price
    }, productName && {
      branding: productName.toLowerCase(),
      product: productName.toLowerCase()
    });
    if (!this._isUserLoggedIn()) {
      setURLParams(this.returnParams);
      svs.components.customer_login.login({
        returnNewCustomer: true,
        extraParams
      });
      return deferred.reject();
    }
    if (this._isUserBlocked()) {
      svs.accountservices.national_suspension_message.showNationalSuspensionPayMessage();
      return deferred.reject();
    }
    if (this._hasDayTimeLimitExpired()) {
      this._showDayTimeLimitInfo();
      return deferred.reject();
    }
    this._accountBalance().done(() => {
      if (this._canAffordPayment({
        price
      })) {
        deferred.resolve();
      } else {
        var _svs, _svs$setupExtraData;
        const setupExtraDataResult = (_svs = svs) === null || _svs === void 0 || (_svs = _svs.accountservices) === null || _svs === void 0 || (_svs = _svs.onboardingHandler) === null || _svs === void 0 || (_svs$setupExtraData = _svs.setupExtraData) === null || _svs$setupExtraData === void 0 ? void 0 : _svs$setupExtraData.call(_svs, {
          extraData: extraParams
        });
        const afterSetupExtraData = () => {
          this._showUserLowBalanceDialog({
            price,
            product: productName
          });
          deferred.reject();
        };
        if (setupExtraDataResult && typeof setupExtraDataResult.then === 'function') {
          setupExtraDataResult.then(afterSetupExtraData, afterSetupExtraData);
        } else {
          afterSetupExtraData();
        }
      }
    }).fail(() => deferred.reject());
    return deferred;
  }
  _isUserLoggedIn() {
    return svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  }
  _isUserBlocked() {
    return svs.core.userSession.isBlocked();
  }
  _hasDayTimeLimitExpired() {
    return svs.day_time_limit && svs.day_time_limit.data && svs.day_time_limit.data.dayTimeLimit && svs.day_time_limit.data.dayTimeLimit.dayTimeExpired;
  }
  _showDayTimeLimitInfo() {
    svs && svs.accountservices && svs.accountservices.day_time_limit && svs.accountservices.day_time_limit.notices && svs.accountservices.day_time_limit.notices.pay();
  }
  _canAffordPayment(_ref2) {
    let {
      price
    } = _ref2;
    const balance = this.balance.replace(/\s*/g, '');
    return parseInt(balance, 10) >= price;
  }
  _accountBalance() {
    const deferred = $.Deferred();
    svs.components.account_balance.get(balance => {
      this.balance = balance;
      deferred.resolve(this.balance);
    });
    return deferred;
  }
  _showUserLowBalanceDialog(_ref3) {
    let {
      price,
      product
    } = _ref3;
    svs.tur.payment.logger.info("Not enough money. Price: ".concat(price, ", balance: ").concat(this.balance));
    new svs.tur.payment.dialogs.UserLowBalance({
      price,
      balance: this.balance,
      returnUrl: "".concat(window.location.href).concat(createQueryString(this.returnParams)),
      onCancel: this.onCancel,
      product,
      isAutoPayAfterDeposit: this.isAutoPayAfterDeposit
    });
  }
}
svs.tur.payment.services.Account = Account;

 })(window);